/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../../node_modules/@types/typeahead/index.d.ts" />
/// <reference path="../../../node_modules/@types/jquery-mask-plugin/index.d.ts" />
/// <reference path="../CISAddressTypeAhead.ts" />
import { AddressTypeAhead } from "../CISAddressTypeAhead";
import { Utility } from "../Shared/Utility";
export { Utility } from "../Shared/Utility";

export class Validate {

    Initialize(): void {
        this.BindSubmitButtonHandler();
        const cisUrl: string = `${location.protocol}//${location.host}/api/Eligibility/TypeaheadAddress`;
        const typeAhead = new AddressTypeAhead(cisUrl);
        typeAhead.Setup("TypeaheadAddress", "MelissaAddressKey", "UnitNumber");

        this.ShowHideCustomerLookupFields($("#CisValidationTypeCode").val());
        this.BindHandlers();
        //getting value from hidden input with ViewBag.AccountNumberMask value
        $("#AccountNumber").mask($("#accountNumberMask").val().toString());
    }

    ShowHideCustomerLookupFields(lookupType): void {
        $("#divBillingNumber").hide();
        $("#divTypeaheadAddress").hide();
        $("#divZipcode").hide();
        $("#divUnit").hide();
        //console.log(lookupType);
        switch (lookupType) {
            case "1":
                $("#divBillingNumber").show();
                $("#divZipcode").show();
                break;
            case "2": 
                $("#divTypeaheadAddress").show();
                break;
        }
    }    

    BindHandlers(): void {
        $("#CisValidationTypeCode").change((() => {
            this.ShowHideCustomerLookupFields($("#CisValidationTypeCode").val());
            this.ResetInputs();
        }));
    }

    ResetInputs(): void {
        $("#AccountNumber").val('');
        $("#TypeaheadAddress").val('');
        $("#ZipCode").val('');
        $("#UnitNumber").val('');
    }

    BindSubmitButtonHandler(): void {
        ///Continue button handles the "submit" on the page
        ///Make sure only one "click" event is processed.
        ///Note: one() will remove the click handler, so if validation fails, it needs to be reattached.
        $("#submitButton").one('click', (evt) => {
            if ($("#validate-form").valid()) {
                $(evt.target).slideUp();
                $("#cancelButton").slideUp();
                $("#validate-form").trigger("submit");
            } else {
                this.BindSubmitButtonHandler();
            }
        });
    }
}

//DOM
((window: any, document: any) => {
    $(() => {
        var validate = new Validate();
        validate.Initialize();
	});
})(window, document);
